export const SITE_LOGO =
  "https://d2naapwr4zpnvs.cloudfront.net/misc/streamily-logo-full-without-tagline.png";

export const SITE_VIDEO_PLACEHOLDER =
  "https://d2naapwr4zpnvs.cloudfront.net/misc/homepage-phone-placeholder.webp";

export const SITE_VIDEO =
  "https://d3qdxs9s8vjwda.cloudfront.net/misc/homepage-phone-video.mp4";
